import * as Core from '@skylab-shared/core';
import { Length, Pattern, ShortestLength } from '@skylab-shared/core';
import { AccountingOnlineReceiverModel } from '../accountancy/accounting-online-receiver.model';
import { FormOfSettlementWithTaxOffice } from './form-of-settlement-with-tax-office';
import { HistoricalEntityModel } from './historical-entity.model';
import { PersonKind } from './person-kind';
import { TaxReturnFrequency } from './tax-return-frequency';
import { VatReleaseReasonSource } from './vat-release-reason-source';
import { ZusContribution } from './zus-contribution';
import { CompanyValidationPatterns } from './company-violation-patterns';

export class CompanyParametersModel extends Core.ModelBase {

    @Core.Property(AccountingOnlineReceiverModel, {nullable: true})
    public accountingOnlineReceiver: AccountingOnlineReceiverModel | null;

    @Core.Property()
    public advanceIncomeTaxPaymentFrequency: TaxReturnFrequency;

    @Core.Property()
    public cashBasis: boolean;

    @Core.Property()
    public formOfSettlement: FormOfSettlementWithTaxOffice;

    @Core.Property()
    public logo: string;

    @Core.Property(HistoricalEntityModel, {nullable: true})
    public otherSeller: HistoricalEntityModel | null;

    @Core.Property(String, { nullable: true })
    public personKind: PersonKind | null;

    @Core.Property(String, {nullable: true})
    public taxOfficeCode: string | null;

    @Core.Property(Date, { nullable: true })
    public taxpayerDateOfBirth: Date;

    @Core.Property()
    @Core.ShortString('data-model.company.validation.taxpayer.firstname.length')
    public taxpayerFirstName: string;

    @Core.Property()
    @Core.ShortString('data-model.company.validation.taxpayer.surname.length')
    public taxpayerSurname: string;

    @Core.Property()
    public ueVatPayer: boolean;

    @Core.Property()
    public vatPayer: boolean;

    @Core.Property()
    public ossRegistered: boolean;

    @Core.Property(String)
    @Core.LongString('data-model.company.validation.vat-release-reason-custom-name.length')
    public vatReleaseReasonCustomName: string | null;

    @Core.Property(Number, { nullable: true })
    public vatReleaseReasonId: number | null;

    @Core.Property(String, { nullable: true })
    public vatReleaseReasonSource?: VatReleaseReasonSource | null;

    @Core.Property()
    public vatReturnFrequency: TaxReturnFrequency;

    @Core.Property()
    public zusContribution: ZusContribution;

    @Core.Property()
    @Length({ max: 9 }, 'data-model.company.validation.bdo-number.length')
    public bdoNumber: string;

    @Core.Property()
    public printBdoNumber: boolean;

    @Core.Property()
    @Length({ max: 17 }, 'data-model.company.validation.eori-number.length')
    public eoriNumber: string;

    @Core.Property()
    public printEoriNumber: boolean;

    @Core.Property()
    public krsNumber: string;

    @Core.Property()
    public printKrsNumber: boolean;

    @Core.Property(String, {nullable: true})
    @Length({max: 255}, 'data-model.company.validation.contact-email.length')
    @Pattern({ pattern: CompanyValidationPatterns.Email}, 'data-model.company.validation.contact-email.pattern')
    public contactEmail: string | null;

    @Core.Property(String, {nullable: true})
    @Length({ max: ShortestLength }, 'data-model.company.validation.contact-phone-number.length')
    @Pattern({ pattern: CompanyValidationPatterns.Phone}, 'data-model.company.validation.contact-phone-number.pattern')
    public contactPhoneNumber: string | null;
}
